import { render } from "./PastDelivery.vue?vue&type=template&id=12fd065f&scoped=true"
import script from "./PastDelivery.vue?vue&type=script&lang=js"
export * from "./PastDelivery.vue?vue&type=script&lang=js"

import "./PastDelivery.vue?vue&type=style&index=0&id=12fd065f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fd065f"]])

export default __exports__